import { Student } from '../types';

/** Em-dash placeholder used everywhere a real student name is missing. */
export const STUDENT_NAME_PLACEHOLDER = '—';

/**
 * Safe display name for a Student row.
 *
 * Student.firstName / lastName are nullable: a row can exist before the parent
 * has filled in the REGISTRATION form. Returns an em-dash placeholder when
 * the names are missing so the UI doesn't invent a fake name like "Unnamed
 * child" — the surrounding row already carries the "Pending registration"
 * status, which gives the reader the right context.
 */
export function studentDisplayName(
  s: Pick<Student, 'firstName' | 'lastName'> | null | undefined
): string {
  if (!s) return STUDENT_NAME_PLACEHOLDER;
  const full = `${s.firstName ?? ''} ${s.lastName ?? ''}`.trim();
  return full.length > 0 ? full : STUDENT_NAME_PLACEHOLDER;
}

/**
 * True when the student row has no real name on file. Useful for styling the
 * placeholder differently (muted text) without re-running the join in the
 * component.
 */
export function isStudentUnnamed(
  s: Pick<Student, 'firstName' | 'lastName'> | null | undefined
): boolean {
  if (!s) return true;
  return `${s.firstName ?? ''} ${s.lastName ?? ''}`.trim().length === 0;
}
